import { render, staticRenderFns } from "./HeaderBottom.vue?vue&type=template&id=6637ed7c&scoped=true&"
import script from "./HeaderBottom.vue?vue&type=script&lang=js&"
export * from "./HeaderBottom.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBottom.vue?vue&type=style&index=0&id=6637ed7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637ed7c",
  null
  
)

export default component.exports